import React, { Component } from 'react';
import Selectivity from 'selectivity/react';
import { Col, FormGroup, Row } from 'reactstrap';
import Api from '../../Api';
import Help from '../../HtmlHelpers';
export default class BaseServerApi extends Component {
  constructor() {
    super(...arguments);
    this.getApiName = () => '';
    this.getApiVersion = () => 1;
    this.getDropdownLabelText = () => '';
    this.getDropdownFieldName = () => '';
    this.getFieldOnly = () => false;
    this.getLabelFieldName = () => 'name';
    this.getPlaceholder = () => 'Select...';
    this.getValueFieldName = () => this.props.valueField || 'uuid';
    this.getApiParams = () => {};
    this.getFilterField = () => 'name';
    this.getOptions = async queryOptions => {
      let options = [];
      const pageSize = 20;
      const apiParams = this.getApiParams() || {};
      if (!apiParams.filtered) {
        apiParams.filtered = [];
      }
      apiParams.filtered.push({
        id: this.getFilterField(),
        value: queryOptions.term
      });
      const params = {
        pageSize,
        page: (queryOptions.offset || 0) / 20,
        filtered: JSON.stringify(apiParams.filtered),
        sorted: JSON.stringify([{
          id: this.getFilterField(),
          desc: false
        }])
      };
      await Api.crudList(this.props.auth, this.getApiName(), params, this.getApiVersion()).then(response => {
        if (response.data !== undefined) {
          this.setState({
            queryResults: this.saveResultsToState(response.data)
          });
          options = {
            results: response.data.map(d => ({
              text: d.attributes[this.getLabelFieldName()],
              id: d.attributes[this.getValueFieldName()]
            })),
            more: (response.page_count - 1) * pageSize > queryOptions.offset + response.data.length
          };
        }
      });
      return options;
    };
    this.saveResultsToState = data => data.reduce((map, obj) => {
      map[obj.attributes[this.getValueFieldName()]] = obj.attributes;
      return map;
    }, {});
    this.onChange = data => this.props.onChange(data);
    this.promiseOptions = (_url, _init, queryOptions) => this.getOptions(queryOptions);
    this.required = () => false;
    this.getContents = labelProps => /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, Help.getWmLabel(labelProps), /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns
    }, /*#__PURE__*/React.createElement(Selectivity.React, {
      ajax: {
        url: 'required',
        minimumInputLength: 3,
        quietMillis: 300,
        fetch: this.promiseOptions
      },
      placeholder: this.getPlaceholder(),
      onSelect: event => {
        const data = event;
        data.fieldName = this.getDropdownFieldName();
        return this.onChange(data);
      },
      defaultValue: this.props.value,
      defaultData: this.props.defaultData,
      required: this.required()
    })));
  }
  render() {
    const labelProps = Object.assign({}, this.props);
    labelProps.text = this.getDropdownLabelText();
    labelProps.htmlFor = this.getDropdownFieldName();
    return this.getFieldOnly() ? this.getContents(labelProps) : /*#__PURE__*/React.createElement(FormGroup, null, this.getContents(labelProps));
  }
}